module.exports = __webpack_public_path__ + "img/banner03.d8d23c42.jpg";